<template>
  <div class="lgi-wrapper">
    <h2>
      <button
        class="guideline-header"
        :aria-expanded="expanded ? 'true' : 'false'"
        @click="toggleExpand">
        <span aria-hidden="true">{{ expanded ? '–' : '+' }}</span>
        {{ getGoalSubjectLabelFromValue(subject.subject) }}
      </button>
    </h2>
    <collapse v-model="expanded">
      <div class="arrow_box">
        <ul class="ul light-bullets">
          <li
            v-for="category in subject.categories"
            :key="category"
            :class="{'locked-option': isSubjectDomainLocked(subject.subject, category)}"
            @click="!isSubjectDomainLocked(subject.subject, category) && openedLink(category)">
            <template v-if="isSubjectDomainLocked(subject.subject, category)">
              <span class="label label-danger lock-label"><i class="fa fa-lock"/></span>
              {{ category }}
            </template>
            <router-link
              v-else
              :to="browseLink(category)"
              target="_blank">
              {{ category }} <OpensInNewTabIcon class="external-link-icon" />
            </router-link>
          </li>
          <li
            class="all-goals"
            :class="{'locked-option': subject.locked}"
            @click="!subject.locked && openedLink(category)">
            <template v-if="subject.locked">
              <span class="label label-danger lock-label"><i class="fa fa-lock"/></span>
              View all {{ subject.subject }} goals
            </template>
            <router-link
              v-else
              :to="browseLink()"
              target="_blank">
              View all {{ subject.subject }} goals <OpensInNewTabIcon class="external-link-icon" />
            </router-link>
          </li>
        </ul>
      </div>
    </collapse>
  </div>
</template>

<script>
import { mapGetters} from 'vuex'
import { noSelMixin } from '@/contentprofile/no_sel_mixins'
import {PremiumLocksMixin} from '@/contentprofile/premium_locks_mixin';
import OpensInNewTabIcon from '../OpensInNewTabIcon.vue';

export default {
  components: { OpensInNewTabIcon },
  name: 'GoalIndexSubject',
  mixins: [noSelMixin, PremiumLocksMixin],
  props: {
    subject: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('visibility')
  },
  methods: {
    toggleExpand() {
      this.$sendEvent('Toggled LGI Subject', {
        lgi_subject: this.subject.subject,
        lgi_expanded: !this.expanded,
      })
      this.$emit('update:expanded', this.subject.subject, !this.expanded)
    },
    browseLink(category) {
      let query = {
        subject: this.subject.subject,
        ref: 'lgi',
      }
      if (category) {
        query.subjectDomain = category
      }
      return { name: 'BrowseGoalsPage', query }
    },
    openedLink(category) {
      this.$sendEvent('Opened LGI Category Link', {
        lgi_subject: this.subject.subject,
        lgi_category: category || 'all',
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.guideline-header {
  background-color: transparent;
  border: none;
  margin-bottom: 10px;
  padding: 0;
  line-height: 1.1rem;
}

.arrow_box {
  background-color: @gray-lightest;

  &:after {
    border-bottom-color: @gray-lightest;
  }

  li {
    .external-link-icon:not(.fa-lock) {
      display: none;
    }

    &:hover, &:focus-within {
      .external-link-icon {
        display: inline;
    }
    }
    a:focus {
      outline-offset: 4px;
    }
    &.locked-option {
      margin-left: -24px;
      list-style: none;
      cursor: not-allowed;
    }
  }
}

.lgi-wrapper {
  margin-bottom: 40px;
}

.ul.light-bullets {
  padding-left: 18px;
  margin: 0;

  li {
     color: #6B6B6B
  }
}

.arrow_box {
  padding: 12px 18px;
}

.all-goals {
  margin-top: 12px;
  list-style-type: none;
}
</style>
